//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "latte-dashboard-auto-save-status",

	data()
	{
		return {
			autoSaveTimings: {
				timeout: 0,
				waited: 0
			},
			dashboard: null,
			isNotSaved: false,
			isSaving: false
		};
	},

	mounted()
	{
		Latte.action.on("latte:dashboard:mounted", dashboard => this.dashboard = dashboard);

		Latte.action.on("latte:dashboard:save", () => this.onSave());
		Latte.action.on("latte:dashboard:saved", () => this.onSaved());
		Latte.action.on("latte:dashboard:auto-save-tick", ({timeout, waited}) => this.onAutoSaveTick(timeout, waited));
		Latte.action.on("latte:dashboard:widgets-changed", widgets => this.onWidgetsChanged(widgets));
	},

	computed: {

		autoSavePercentage()
		{
			if (this.autoSaveTimings.waited === 0 || this.autoSaveTimings.timeout === 0)
				return 0;

			return this.autoSaveTimings.waited / this.autoSaveTimings.timeout;
		},

		buttonClasses()
		{
			const classes = ["btn", "btn-primary"];

			if (this.isSaving)
				classes.push("btn-text");
			else if (this.isNotSaved)
				classes.push("btn-outline");

			return classes;
		},

		shouldShowButton()
		{
			return this.dashboard !== null && (this.isSaving || this.isNotSaved);
		}

	},

	methods: {

		onAutoSaveTick(timeout, waited)
		{
			this.autoSaveTimings.timeout = timeout;
			this.autoSaveTimings.waited = waited;
		},

		onSave()
		{
			this.isSaving = true;
		},

		onSaved()
		{
			this.isNotSaved = false;
			this.isSaving = false;

			this.autoSaveTimings.timeout = 0;
			this.autoSaveTimings.waited = 0;
		},

		onWidgetsChanged()
		{
			this.isNotSaved = true;
		}

	}

}

